import React, { useContext, useCallback } from "react";
import { useNavigate } from "react-router-dom";
import Modal from "../UI/Modal";
import Card from "../UI/Card";
import Button from "../UI/Button";
import { Body, Heading, Helper } from "../UI/Text";
import { PageWrapper } from "../UI/Grid";
import Table from "../UI/Table";
import { Flex } from "reflexbox";
import formatter from "../../modules/formatter";
import ConfiguratorContext from "../../context/configurator/ConfiguratorContext";
import { useTheme } from "styled-components";
import { Columns } from "./columns";
import UserContext from "../../context/user/UserContext";
import * as constants from "../../modules/constants";
import { createQuote } from "../../requests/quoteManagementRequests";
import guid from "../../modules/guid";

const PageView = ({
  showPreview,
  setShowPreview,
  data,
  gridData,
  refetchQuery,
  isLoading,
}) => {
  const theme = useTheme();
  const navigate = useNavigate();
  const {
    activeProduct,
    setActiveProduct,
    setIsReconfigure,
    setConfiguratorMode,
  } = useContext(ConfiguratorContext);

  const { loggedIn, activeUser, pid, platform } = useContext(UserContext);

  const onProductPageClick = useCallback(
    (row) => {
      setShowPreview(true);
      setActiveProduct(row);
    },
    [setActiveProduct, setShowPreview]
  );
  const onProductClick = useCallback(
    async (e) => {
      e.stopPropagation();
      setIsReconfigure(false);
      const { ID: productId } = activeProduct || {};
      setConfiguratorMode(constants.CONFIGURATOR_MODES.Default);
      const newId = guid.GenerateGUID();

      const response = await createQuote({
        input: {
          username: !loggedIn ? "" : activeUser?.username,
          createdByFirstName: !loggedIn ? "" : activeUser?.firstName,
          createdByLastName: !loggedIn ? "" : activeUser?.lastName,
          type: activeUser?.roleLevel === 0 || !loggedIn ? 3 : 1,
          _id: newId,
          pid: pid || platform?.id,
          createdByUserId: !loggedIn ? "" : activeUser?.id,
          groupId: !loggedIn ? "" : activeUser?.groupId,
        },
      });
      try {
        const { id: quoteId } = response || {};
        console.log(activeProduct, { response });

        navigate(`/Configurator/${productId}/${quoteId}/${quoteId}_1`);
      } catch (error) {
        console.log(activeProduct, { response });
        console.error(error);
      }
    },
    [
      platform,
      loggedIn,
      activeProduct,
      activeUser,
      navigate,
      pid,
      setConfiguratorMode,
      setIsReconfigure,
    ]
  );

  const {
    Name,
    img,
    Description,
    ID,
    Overview,
    priceCode,
    defaultPrice,
    quantityInStock,
    UOM,
    RelatedItem,
    ImageUrl,
    base64Image,
  } = activeProduct || {};

  const image = img || base64Image || ImageUrl;

  return (
    <>
      <Modal show={showPreview} setShow={setShowPreview}>
        <Card minWidth={["300px", "330px", "400px", "600px"]}>
          <Flex width={1} mb="1rem" justifyContent="space-between">
            <Card
              mr="3rem"
              width={["100px", "100px", "150px", "200px"]}
              height={["100px", "100px", "150px", "200px"]}
              justifyContent="center"
            >
              <img
                style={{ margin: "auto" }}
                src={image}
                alt={`Product #${ID}`}
              />
            </Card>

            <Flex flexDirection="column" alignItems="flex-end">
              <Heading right>{Name}</Heading>

              <Body mb="1rem" bold color={theme.secondary} right>
                ${formatter.currency(defaultPrice)}
              </Body>

              {loggedIn ? null : (
                <Button onClick={onProductClick}>Configure</Button>
              )}

              {priceCode && <Body right>Price Code: {priceCode}</Body>}

              {!quantityInStock ? null : (
                <Body right>In Stock: {quantityInStock}</Body>
              )}

              {!UOM ? null : <Body right>Unit of Measure: {UOM}</Body>}

              {!RelatedItem ? null : (
                <Body right>Related Item: {RelatedItem}</Body>
              )}
            </Flex>
          </Flex>

          {!Description ? null : (
            <Flex width={1} flexDirection="column">
              <Helper bold>Product Description</Helper>
              <Body>{Description}</Body>
            </Flex>
          )}

          {!Overview ? null : (
            <Flex width={1} flexDirection="column">
              <Helper bold>Product Overview</Helper>
              <Body>{Overview}</Body>
            </Flex>
          )}

          <Button
            title="Close Pane"
            size="small"
            color={theme.gray}
            m="1rem auto 0 auto"
            reverse
            onClick={() => setShowPreview(false)}
          >
            Close
          </Button>
        </Card>
      </Modal>
      <PageWrapper>
        <Table
          hideBack
          hideCreate
          isLoading={isLoading}
          hideRefetch={false}
          title="Product Catalog"
          refetchData={refetchQuery}
          columns={Columns(onProductPageClick, true)}
          gridSize="small"
          gridData={gridData}
          data={data?.rows || []}
          forceGrid
          hideProperties
          totalCount={data?.count || 0}
          onCardClick={(row) => onProductPageClick(row)}
        />
      </PageWrapper>
    </>
  );
};

export default PageView;
